module.exports = __webpack_public_path__ + "img/title2.1a92070a.png";